import * as React from "react";

import Modal from "react-modal";

import { IAlert } from "./classes/Alert";
import { IText } from "./classes/Text";

import { UnifiedPublishingModalContent } from "./UnifiedPublishingModalContent";

/*
See
https://github.com/reactjs/react-modal/issues/497
https://github.com/webpack/webpack/issues/6576
*/

export interface IUnifiedPublishingModal {
	liveAlerts: IAlert[];
	displayModal: boolean;
	modalIsMinimized: boolean;
	numAjaxRequests: number;
	text: IText;
	onMinimizeModal: (event: any) => any;
}

export class UnifiedPublishingModal extends React.Component<IUnifiedPublishingModal, any> {

	private parentElementSelector = "body";

	constructor(props, context) {
		super(props, context);
	}

	public componentWillMount() {
		Modal.setAppElement(this.parentElementSelector);
	}

	public render() {

		const props = this.props;

		const getParent = () => {
			return document.querySelector(this.parentElementSelector);
		};

		if (props.displayModal && !props.modalIsMinimized) {

			return (
				<React.Fragment>
					<Modal
						isOpen={props.displayModal}
						parentSelector={getParent}
						className={"ReactModal__Content ReactModal__Content--after-open ReactModal__Content"}
						overlayClassName={"ReactModal__Overlay ReactModal__Overlay--after-open ReactModal__Overlay CMS_PF_dialog CMS_PF_react CMS_react_ScrollingDialog"}
						shouldCloseOnOverlayClick={false}
						shouldCloseOnEsc={false}
						onRequestClose={props.onMinimizeModal}
					>

						<UnifiedPublishingModalContent
							liveAlerts={this.props.liveAlerts}
							numAjaxRequests={this.props.numAjaxRequests}
							text={this.props.text}
							onClickCloseModalButton={props.onMinimizeModal}
						/>

					</Modal>

				</React.Fragment>
			);

		} else {
			return null;
		}

	}
};
